module.exports = __webpack_public_path__ + "img/esg-banner4-logo.e64a5808.png";